import { Space, message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getUserDataLists, deleteUser } from "../apis/user";
import ViewUserDetails from "../components/ViewUserDetails";
import CommonTable from "../components/common/CommonTable";
import CutOffText from "../components/common/CutOffText";
import { useLoader } from "../components/common/Loader/LoaderProvider";
import ActionsModal from "../components/common/Modals/ActionsModal";
import TableAction from "../components/common/TableAction";
import CustomLayout from "../components/layout/CustomLayout";
import withAuth from "../routeProtector/withAuth";
import { subscribedData } from "../utils/constant";
import { useRef } from "react";
import useDocumentTitle from "../utils/useDocumentTitle";

const Customer = () => {
  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalItems, setTotalItems] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [subscribed, setSubscribed] = useState("all" || null);
  // const [status, setStatus] = useState("all" || null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedField, setSortedField] = useState("first_name"); // Tracks the sorted field
  const [deleteData, setDeleteData] = useState(false);
  const [deleteModel, setDeleteModal] = useState(false);
  console.log("deleteModel", deleteModel);
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [description, setDescription] = useState("");
  const [error, setError] = useState(false);
  const loaderContext = useLoader();
  const { showLoader, hideLoader } = loaderContext;
  useDocumentTitle("Customer");
  const data = {
    // filter: subscribed,
    page: currentPage,
    limit: limit,
    searchQuery: searchInput.trim(),
    sortBy: sortedField,
    sortOrder: sortOrder,
  };
  console.log("description", description);
  const fetchUserData = async () => {
    showLoader();
    dispatch(getUserDataLists(data))
      .then((res) => {
        // console.log("res=>>>>", res);
        if (res.status) {
          console.log("res=>>>>", res?.data);
          setUserData(res?.data?.data?.users);
          // setTota(res?.data?.data?.totalPages);
          setTotalItems(res?.data?.data?.totalUsers);
          setCurrentPage(res?.data?.data?.currentPage);
          hideLoader();
        } else {
          hideLoader();
        }
      })
      .finally(() => {
        hideLoader();
      });
  };
  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, [limit, currentPage, searchInput, sortedField, sortOrder]);
  console.log("user data:", userData);
  const handleView = (record) => {
    setSelectedUser(record);
    setShowUserDetails(true);
  };

  const handleDelete = (record) => {
    setDeleteData(record);
    setDeleteModal(true);
  };

  const handleDeleteUser = async () => {
    console.log("deleteData", deleteData._id);
    try {
      if (!deleteData?._id) {
        setError(true);
        return;
      }
      // Call the deleteUser API with the selected user's id
      const response = await dispatch(deleteUser(deleteData._id));
      if (response.status) {
        message.success("Customer deleted successfully");
        setDescription("");
        setError(false);
        setDeleteData(null);
        setDeleteModal(false);
        fetchUserData(); // Refresh the list after deletion
      } else {
        setError(true);
        console.error(response.message);
      }
    } catch (err) {
      setDeleteData(null);
      setDeleteModal(false);
      setError(false);
      console.error("Error while deleting user:", err);
    }
  };

  const handleSort = (field) => {
    if (sortedField === field) {
      // Toggle sort order if the same column is clicked again
      setSortOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
    } else {
      // Set the new column and default to ascending
      setSortedField(field);
      setSortOrder("asc");
    }
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      sorter: true,
      onHeaderCell: () => ({
        onClick: () => handleSort("first_name"),
      }),
      render: (text) => <>{<CutOffText maxLength={20} value={text} />}</>,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      sorter: true,

      onHeaderCell: () => ({
        onClick: () => handleSort("last_name"),
      }),
      render: (text) => <>{<CutOffText maxLength={20} value={text} />}</>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
      render: (text) => <CutOffText maxLength={20} value={text} />,
      sorter: true,

      onHeaderCell: () => ({
        onClick: () => handleSort("email"),
      }),
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (_, text) => (
        <>{!text ? "-" : text.country_code + " " + text.phone_number}</>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <TableAction
            view={true}
            onView={() => handleView(record)}
            deleteU={true}
            onDelete={() => handleDelete(record)}
            traceData={true}
          />
        </Space>
      ),
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSizeChange = (current, size) => {
    setLimit(size);
  };

  return (
    <CustomLayout>
      {showUserDetails ? (
        <ViewUserDetails
          user={selectedUser}
          setShowUserDetails={setShowUserDetails}
        />
      ) : (
        <>
          <CommonTable
            apiData={userData && userData}
            columns={columns}
            currentPage={currentPage}
            itemsPerPage={limit}
            onPageChange={handlePageChange}
            onShowSizeChange={handleSizeChange}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            totalItems={totalItems}
            filter={false}
            showCSV={false}
            // additionalFilters={[
            //   {
            //     defaultValue: subscribed,
            //     value: subscribed,
            //     placeholder: "Select Subscription",
            //     onChange: (value) => setSubscribed(value),
            //     options: subscribedData,
            //   },
            // ]}
          />

          {deleteModel && (
            <ActionsModal
              title=""
              type="delete"
              isOpen={deleteModel}
              onCancel={() => setDeleteModal(false)}
              onOk={handleDeleteUser}
              footer={false}
              centered={true}
              closable={false}
              maskClosable={false}
              className="delete-modal"
              cancelBtnClass="cancleBtnAction"
              cancelBtnClick={() => setDeleteModal(false)}
              cancelButtonProps="Cancel"
              saveBtnClass="saveBtnAction"
              saveBtnClick={handleDeleteUser}
              saveButtonProps={"Delete"}
              description={`Do you really want to delete these record?`}
              mainTitle="Are you sure?"
              // notes={disableUser.blocked ? false : true}
              enteredNotes={description}
              setNotes={setDescription}
              error={error}
              setError={setError}
            />
          )}
        </>
      )}
    </CustomLayout>
  );
};

export default withAuth(Customer);
